// eslint-disable-next-line import/prefer-default-export
export const compareObjects = (obj1, obj2) =>
  JSON.stringify(obj1) === JSON.stringify(obj2);
